import { useMemo } from 'react';

import { usePricesContext } from '@/src/providers/PricesProvider';

export const usePrice = (
  serviceType: 'image' | 'video' | 'audio',
  serviceKey: string,
) => {
  const allPrices = usePricesContext();

  const price = useMemo(() => {
    return allPrices.find(
      (price) =>
        price.serviceType === serviceType &&
        price.specificService === serviceKey,
    );
  }, [allPrices, serviceType, serviceKey]);

  return price!;
};
